export enum ServiceProvider {
  Dropbox = 'dropbox',
  Google = 'google',
  Microsoft = 'microsoft',
  Zoho = 'zoho',
}

export type ServiceProviderMap<T> = Record<ServiceProvider, T>;

export function isServiceProvider(value: any): value is ServiceProvider {
  return Object.values(ServiceProvider).includes(value);
}

export function assertIsServiceProvider(value: any): asserts value is ServiceProvider {
  if (!isServiceProvider(value)) {
    throw new Error(`Invalid service provider: ${value}`);
  }
}

export function getAllServiceProviders(): ServiceProvider[] {
  return [
    ServiceProvider.Dropbox,
    ServiceProvider.Google,
    ServiceProvider.Microsoft,
    ServiceProvider.Zoho,
  ];
}

export function getServiceProviderName(provider: ServiceProvider): string {
  const nameMap: ServiceProviderMap<string> = {
    [ServiceProvider.Dropbox]: 'Dropbox',
    [ServiceProvider.Google]: 'Google',
    [ServiceProvider.Microsoft]: 'Microsoft',
    [ServiceProvider.Zoho]: 'Zoho',
  };

  return nameMap[provider];
}

export function getStorageName(provider: ServiceProvider): string {
  const nameMap: ServiceProviderMap<string> = {
    [ServiceProvider.Dropbox]: 'Dropbox',
    [ServiceProvider.Google]: 'Google Drive',
    [ServiceProvider.Microsoft]: 'Microsoft OneDrive',
    [ServiceProvider.Zoho]: 'Zoho WorkDrive',
  };

  return nameMap[provider];
}

export function getStorageIcon(provider: ServiceProvider): string {
  return `/assets/storage-${provider}-icon.svg`;
}
